import Fuse from 'fuse.js';

// Fuzzy search over the user's thoughts (the /search page).
//
// Unlike the Library's "Your Thoughts" box (filterThoughtsBySearchTerm — a
// literal case-insensitive substring filter), this is typo-tolerant and ranks
// by relevance. It searches the same fields, weighted so a body hit outranks a
// theme/motif/tag hit for the same term.
export const THOUGHT_FUSE_OPTIONS = {
  // ignoreLocation: a match anywhere in a long body counts (don't privilege the
  // start of the string). threshold 0.4 is a middle ground — forgiving enough
  // for small typos, strict enough that unrelated thoughts don't flood in.
  ignoreLocation: true,
  threshold: 0.4,
  minMatchCharLength: 2,
  keys: [
    { name: 'thought', weight: 0.6 }, // the body — what people actually search
    { name: 'theme', weight: 0.15 },
    { name: 'motif', weight: 0.15 },
    { name: 'tags', weight: 0.1 },
  ],
};

// Build a reusable Fuse index. Callers that search repeatedly (a page reacting
// to keystrokes) should memoize this over the corpus and reuse it, rather than
// rebuilding per keystroke.
export const buildThoughtIndex = (thoughts) =>
  new Fuse(thoughts || [], THOUGHT_FUSE_OPTIONS);

// Convenience: one-shot fuzzy search. Empty/whitespace term returns [] (the
// search page shows a prompt rather than the whole corpus). Results are ordered
// by Fuse relevance (best first).
export const fuzzySearchThoughts = (thoughts, term) => {
  const q = (term || '').trim();
  if (!q) return [];
  return buildThoughtIndex(thoughts).search(q).map((r) => r.item);
};
